import { FormField } from "@babackapp/ui/components/form";
import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormInputRow from "@babackapp/react-hook-forms-components/form-input-row";
import FormOptionsSelector from "@babackapp/react-hook-forms-components/form-option-selector";
import FormTagsInput from "@babackapp/react-hook-forms-components/form-tags-input";
import { useFormContext } from "react-hook-form";
import { useOptions } from "./discount-settings-form-options";
import DiscountSettingsFreeShippingForm from "./discount-settings-free-shipping-form";
import { useDiscountDisabled } from "./use-form-section-disabled";
import { DiscountSettingsFormValues } from "./discount-settings-form";
import useTranslation from "@babackapp/translations/use-translation";
import FormSwitch from "@babackapp/react-hook-forms-components/form-switch";

export default function DiscountSettingsActivatedForm() {
  const t = useTranslation();

  const { control } = useFormContext<DiscountSettingsFormValues>();
  const { discountBonusOptions, discountAvailabilityOptions, giftCardOptions } =
    useOptions();

  const disabled = useDiscountDisabled();

  return (
    <>
      <FormInputRow>
        <FormField
          control={control}
          name="giftCard"
          render={({ field }) => (
            <FormOptionsSelector
              label={t("settings.config.discount.giftCard.title")}
              description={t("settings.config.discount.giftCard.description")}
              options={giftCardOptions}
              value={field.value}
              onChange={field.onChange}
              disabled={disabled}
            />
          )}
        />

        <FormField
          control={control}
          name="validity"
          render={({ field }) => (
            <FormOptionsSelector
              label={t("settings.config.discount.validity.title")}
              description={t("settings.config.discount.validity.description")}
              options={discountAvailabilityOptions}
              value={field.value}
              onChange={field.onChange}
              disabled={disabled}
            />
          )}
        />
      </FormInputRow>
      <FormField
        control={control}
        name="applyReturnShippingFeesForDiscountRule"
        render={({ field }) => (
          <FormSwitch
            label={t(
              "settings.config.discount.applyReturnShippingFeesForDiscountRule.title",
            )}
            description={t(
              "settings.config.discount.applyReturnShippingFeesForDiscountRule.description",
            )}
            value={field.value ?? false}
            onChange={field.onChange}
            disabled={disabled}
          />
        )}
      />
      <FormInputRow>
        <FormField
          control={control}
          name="discount_bonus.amount"
          render={({ field }) => (
            <FormInput
              label={t("settings.config.discount.bonusAmount.title")}
              type="number"
              value={field.value}
              onChange={(e) => field.onChange(e.target.valueAsNumber)}
              disabled={disabled}
            />
          )}
        />

        <FormField
          control={control}
          name="discount_bonus.type"
          render={({ field }) => (
            <FormOptionsSelector
              label={t("settings.config.discount.bonusType.title")}
              options={discountBonusOptions}
              value={field.value}
              onChange={field.onChange}
              disabled={disabled}
            />
          )}
        />
      </FormInputRow>

      <FormField
        control={control}
        name="tagsForNotAcceptedDiscount"
        render={({ field }) => (
          <FormTagsInput
            label={t(
              "settings.config.discount.tagsForNotAcceptedDiscount.title",
            )}
            description={t(
              "settings.config.discount.tagsForNotAcceptedDiscount.description",
            )}
            value={field.value}
            onChange={field.onChange}
            disabled={disabled}
          />
        )}
      />
      <FormField
        control={control}
        name="discountAcceptedCountries"
        render={({ field }) => (
          <FormTagsInput
            label={t(
              "settings.config.discount.discountAcceptedCountries.title",
            )}
            description={t(
              "settings.config.discount.discountAcceptedCountries.description",
            )}
            value={field.value}
            onChange={field.onChange}
            disabled={disabled}
          />
        )}
      />

      {/* <FormField
        control={control}
        name="codesToIgnoreRegex"
        render={({ field }) => (
          <FormInput
            label={t("settings.config.discount.codesToIgnore.title")}
            type="string"
            readOnly={true}
            value={field.value}
          />
        )}
      /> */}

      <DiscountSettingsFreeShippingForm />
    </>
  );
}
